<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "sysTask",
      key: "id",
      kv: "",
      selectC: "",
      url: {},
      items: [
        { label: "新增发票", desc: "新增合同发票", type: "header" },
        {
          label: "合同名称",
          name: "contractId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: false,
              message: "合同不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
        },
        {
          label: "发票金额(元)",
          name: "invoicePrice",
          value: "",
          type: "number",
          width: "400px",
          rules: [{ required: true, trigger: "blur", type: "number" }],
          min: 0,
          formatter: (value) => `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
        },
        {
          label: "款项内容",
          name: "paymentContent",
          value: "",
          width: "400px",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "付款要求",
          name: "paymentRequirements",
          value: "",
          width: "400px",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "预开票时间",
          name: "estimatedInvoicingTime",
          value: " ",
          type: "date",
          format: "yyyy-MM-dd",
        },
        {
          label: "预付款时间",
          name: "expectedPaymentTime",
          value: " ",
          type: "date",
          format: "yyyy-MM-dd",
        },
        {
          label: "发票状态",
          name: "state",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "待开票",
            },
            {
              value: 2,
              name: "已开票",
            },
            // {
            //   value: 3,
            //   name: "发票退回",
            // },
            {
              value: 4,
              name: "移交财务",
            },
            {
              value: 5,
              name: "已支付",
            },
          ],
          onChange: this.onisParent,
        },
        {
          label: "发票文件",
          name: "invoiceUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        {
          label: "附件",
          name: "remarkUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
      ],
      forms: {},
    };
  },
  created() {
    let query = this.$route.query;
    this.forms.projectId = localStorage.getItem("projectId");
    if (query.action === "edit") {
      if (query.id) {
        this.forms.id = query.id;
        this.initData(query.id);
        this.loadLevelData();
      }
    } else {
      this.loadLevelData();
    }
  },
  mounted() {},
  methods: {
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {
        projectId: localStorage.getItem("projectId"),
      };
      $utils.api.load(`/admin/system/contract/list`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "contractId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    initData(id) {
      if (!id) {
        return;
      }
      $utils.api.load(`/admin/system/invoice/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          console.log(res.data);
        }
      });
    },
    async handleSubmit() {
      let q = this.forms;
      q.expectedPaymentTime = this.forms.expectedPaymentTime ? (this.forms.expectedPaymentTime + " 00:00:00") : null;
      q.estimatedInvoicingTime = this.forms.estimatedInvoicingTime ? (this.forms.estimatedInvoicingTime + " 00:00:00") : null;
       await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/invoice`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
  },
};
</script>
